export default {
  canSnapTo: false,
  controlledByParent: true,
  multiselectable: false,
};
